import { awIntegrationsApi } from './Base';
import { NewsArticle } from './types';

export function getNewsArticle({ articleId, pkg, platformId }: { articleId: string; pkg: string; platformId: string }) {
  const path = `/partners/news/v1/newsArticles/${articleId}`;
  return awIntegrationsApi.get<NewsArticle>(path, {
    params: { pkg, platformId },
  });
}
